import React from "react";

interface InputSwitchProps {
    name: string;
    label: string;
    value: boolean;
    onChange: (val: boolean) => void;
    required?: boolean;
    error?: string;
    disabled?: boolean;
}

const InputSwitch: React.FC<InputSwitchProps> = ({
                                                     name,
                                                     label,
                                                     value,
                                                     onChange,
                                                     required = false,
                                                     error = "",
                                                     disabled = false,
                                                 }) => {
    return (
        <div className="w-full my-4">
            <div className="w-full flex justify-between px-2">
                {/* لیبل بالای سوییچ */}
                <label
                    className="flex items-center font-bold text-sm"
                    htmlFor={name}
                >
                    {label} {required && <span className="text-red-500 font-light">*</span>}
                </label>

                {/* خود سوییچ */}
                <div className="flex items-center justify-center py-3">
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            id={name}
                            type="checkbox"
                            className="sr-only peer"
                            checked={value}
                            onChange={(e) => onChange(e.target.checked)}
                            disabled={disabled}
                        />
                        <div
                            className={`w-11 h-6 rounded-full transition-colors
              ${disabled ? "bg-gray-300 cursor-not-allowed" : "bg-gray-300 peer-checked:bg-blue-600"}
              relative
              after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white 
              after:border after:border-gray-300 after:rounded-full after:h-5 after:w-5 after:transition-all
              peer-checked:after:translate-x-5`}
                        ></div>
                    </label>
                </div>

                {error && <p className="text-red-500 text-xs mt-2 text-center">{error}</p>}
            </div>
        </div>
    );
};

export default InputSwitch;
